export const IntroController = {
    index(): void {},
    brandFilm(): void {},
    gate(): void {},
};
